import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'sub-classifications',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'sub-classifications-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.sub-classifications-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "sub-classifications-index" */ '@/modules/configurations/catalogs/sub-classifications/views/Index.vue')
        },
        {
            path: 'create',
            name: 'sub-classifications-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'sub-classifications-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.sub-classifications-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.sub-classifications-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "sub-classifications-create" */ '@/modules/configurations/catalogs/sub-classifications/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'sub-classifications-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'sub-classifications-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.sub-classifications-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.sub-classifications-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "sub-classifications-edit" */ '@/modules/configurations/catalogs/sub-classifications/views/Edit.vue')
        }
    ]
}